import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class BigSubmenu {

  constructor() {
    this.$container = $('.big-submenu')

    if (this.$container === undefined) {
      return
    }

    this.classes = {
      'title': 'big-submenu-title',
      'submenuItemsOpen': 'open',
      'mobileOpenNav': 'open-nav',
    }

    this.$window = $(window)
    this.$body = $('body')
    this.$title = this.$container.find(`.${this.classes.title}`)
    this.$submenuItems = this.$container.find('ul li.menu-item-has-children')

    this.$window.on('load resize scroll', this.handleScroll.bind(this))
    this.$window.on('click', this.handleClickWindow.bind(this))

    this.$submenuItems.on('click', '> a', this.handleClickSubmenuItems.bind(this))

    // Mobile
    this.$title.on('click', this.handleClickTitle.bind(this))
  }

  handleScroll(e) {
    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
  }

  throttle(callback, delay) {
      var last;
      var timer;
      return function () {
          var context = this;
          var now = +new Date();
          var args = arguments;
          if (last && now < last + delay) {
              // le délai n'est pas écoulé on reset le timer
              clearTimeout(timer);
              timer = setTimeout(function () {
                  last = now;
                  callback.apply(context, args);
              }, delay);
          } else {
              last = now;
              callback.apply(context, args);
          }
      };
  }

  handleClickTitle(e) {
    if ( ! Core.matchesMedia('header') ) {
      e.preventDefault()
      this.$container.toggleClass(this.classes.mobileOpenNav)
    }
  }

  handleClickSubmenuItems(e) {
    e.preventDefault()
    let $li = $(e.target).closest('li')

    if ( $li.hasClass(this.classes.submenuItemsOpen) ) {
      $li.removeClass(this.classes.submenuItemsOpen)
      return
    }

    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
    $li.toggleClass(this.classes.submenuItemsOpen)
  }

  handleClickWindow(e) {
    let $item = $(e.target).closest('.big-submenu')

    if ( $item.length ) {
      return
    }

    this.$container.removeClass(this.classes.mobileOpenNav)
    this.$submenuItems.removeClass(this.classes.submenuItemsOpen)
  }
}
